// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__22ETu","footer":"ModalInfo_footer__3MJQr"};